import { render, staticRenderFns } from "./PFCustomerPoliticallyExposedPerson.vue?vue&type=template&id=9b101950"
import script from "./PFCustomerPoliticallyExposedPerson.vue?vue&type=script&lang=js"
export * from "./PFCustomerPoliticallyExposedPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports